import { adgAdConfig } from '../../config';
import { adgAdDefaultConfig } from '../../config/ad/default';

import { $ } from '../Util';

/**
 * ターゲットID
 */
let adTargetID = 0;

/**
 * AdGeneration
 */
export default class AdGeneration {
    /**
     * コンストラクタ
     * @param {object} adparam 広告パラメータ
     * @param {string} adFrameType  広告枠
     * @param {object} option  オプション
     */
    constructor(adparam, adFrameType, option) {
        const { vendor, id, displayid, adType } = adparam;
        /** @property {object} adConfig 広告設定 */
        this.adConfig = vendor
            ? adgAdConfig[process.env.DISTRIBUTION][vendor][adFrameType]
            : {
                ...adgAdDefaultConfig,
                id,
                displayid,
                adType,
            };

        /** @property {object} option オプション */
        this.option = option;
        /** @property {HTMLElement} $elem 広告枠エレメント */
        this.$elem = this.initElement(adFrameType);
    }

    /**
     * 広告枠の初期化
     *
     * @param {string} adFrameType 広告枠タイプ
     */
    initElement(adFrameType) {
        const element = this.adConfig.preFixId;
        const modifier = `-${adFrameType}`;

        const existingAd = $(`.${element}.${modifier}`);
        if (existingAd) {
            return existingAd;
        }

        const ad = document.createElement('div');
        ad.id = `${this.adConfig.preFixId}${this.adConfig.id}`;
        ad.classList.add(element, modifier);
        this.option.target.appendChild(ad);
        return ad;
    }

    /**
     * 広告読み込み処理
     */
    load() {
        const existingAd = $(`script.${this.adConfig.preFixId}${this.adConfig.id}`);
        let tag = '';
        if (existingAd) {
            const existingAdRefresh = $(`script.${this.adConfig.preFixId}${this.adConfig.id}-refresh`);
            if (existingAdRefresh) {
                existingAdRefresh.remove();
            }
            tag = document.createElement('script');
            tag.className = `${this.adConfig.preFixId}${this.adConfig.id}-refresh`
            tag.text = `
                googletag.cmd.push(function () {
                    googletag.pubads().refresh();
                });
            `;
        } else {
            tag = document.createElement('script');
            tag.className = `${this.adConfig.preFixId}${this.adConfig.id}`
            tag.text = `
                googletag.cmd.push(function () {
                    googletag.defineSlot('${this.adConfig.defineSlot.link}', ${this.adConfig.defineSlot.size}, '${this.adConfig.preFixId}${this.adConfig.id}').addService(googletag.pubads());
                    googletag.pubads().enableSingleRequest();
                    googletag.enableServices();
                    googletag.display('${this.adConfig.preFixId}${this.adConfig.id}');
                });
            `;
        }



        this.$elem.after(tag);
    }

    /**
     * 広告が読み込まれているか
     */
    isLoaded() {
        return this.$elem.children.length > 0;
    }

    /**
     * 広告リセット処理
     */
    remove() {
        this.$elem.innerHTML = '';
    }

    /**
     * 非表示にする
     */
    hide() {
        this.$elem.style.display = 'none';
    }

    /**
     * 表示する
     */
    show() {
        this.$elem.style.display = '';
    }
}
